<template>
  <div class="a-programs-container">
      <div class="container">
        <div class="a-slider-container">
          <div class="a-slider-header d-flex justify-content-between align-items-center">
            <div class="bg-title">Explore our Programs</div>
            <div class="a-arrows">
              <button @click="prev" class="arrow-btn">
                <span class="icon-arrow-left icon-arr"></span>
              </button>
              <button @click="next" class="arrow-btn">
                <span class="icon-arrow-right icon-arr"></span>
              </button>
            </div>
          </div>
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(row, index) in rows" :key="index" :data-swiper-autoplay="row.duration + '000'">
              <div class="a-program-card">
                <img :src="row.image" class="a-program-card-view img-fluid" alt="" />
                <div class="a-program-cbody">
                  <div class="title" v-html="row.title"></div>
                  <router-link v-if="row.button" :to="row.redirect" class="d-inline-block a-rd-more-btn">
                    <div class="d-flex align-items-center">
                      <span v-html="row.button"></span>
                      <span class="icon-back icon"></span>
                    </div>
                  </router-link>
                </div>
              </div>
            </swiper-slide>      
          </swiper>
        </div>
      </div>
  </div>
</template>

<style scoped>
.a-programs-container {
  padding: 60px 0
}
.a-program-cbody {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0
}
.title {
  color: #00197E;
  font-weight: bold;
}
.a-rd-more-btn {
  border: 1px solid #00197E;
  color: #00197E;
  padding: 4px 15px;
  font-size: 16px;
  font-weight: 600;
}
.a-rd-more-btn .icon:before {
  color: #00197E;
  font-weight: bold;
}
.a-rd-more-btn:hover {
  background: #00197E;
  color: #fff;
}
.a-rd-more-btn:hover .icon:before {
  color: #fff;
}
.a-rd-more-btn:active {
  opacity: 0.6;
}
.a-program-card-view {
  height: 226px;
  object-fit: cover;
  width: 100%;
}
.arrow-btn {
  margin-left: 15px;
}
.arrow-btn:active {
  opacity: 0.6;
}
.arrow-btn:hover .icon-arr {
  color: #000000;
}
.icon-arr {
  font-weight: bold;
  font-size: 25px;
  color: #585858;
}
.a-slider-header {
  padding: 13px 0;
  margin-bottom: 15px;
  border-top: 2px solid #001157;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .bg-title {
    font-size: 23px;
  }
  .a-rd-more-btn {
    margin-right: 1px;
  }
  .a-program-cbody .title {
    width: calc(100% - 135px)
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .a-rd-more-btn {
    margin-right: 1px;
  }
.a-program-cbody .title {
    width: calc(100% - 135px)
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
// Very Important npm install swiper@5.4.5 
import axios from 'axios';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: "Section1",
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      rows: [
        // {
        //   id: 1,
        //   title: 'Marketing Management',
        //   image: require('../../assets/ami/program-1.png')
        // },
        // {
        //   id: 2,
        //   title: 'H.R Management',
        //   image: require('../../assets/ami/program-2.png')
        // },
        // {
        //   id: 3,
        //   title: 'H.R Management',
        //   image: require('../../assets/ami/program-2.png')
        // }
      ],
      duration: 5,
      speed: 800,
      swiperOptions: {
        loop: false,
        autoplay: {
          // delay: 4000, or data-swiper-autoplay="2000" in html
        },
        spaceBetween: 30,
        // slidesPerView: 3,
        navigation: {
            nextEl: '.swiperNext',
            prevEl: '.swiperPrev'
        },
        breakpoints: {
          767: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 2
          },
          1200: {
            slidesPerView: 2
          }
        }
      }
    }
  },
  created() {
    this.fetchSlider();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    prev() {
			this.$refs.mySwiper.$swiper.slidePrev();
		},
		next() {
			this.$refs.mySwiper.$swiper.slideNext();
		},
    fetchSlider() {
      axios
        .get(window.baseURL + "/programsInHome")
        .then((res) => {
          this.pgLoading = false;
          const data = res.data.row;
          this.rows = data;
          console.log(data);
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.swiper.slideTo(3, 1000, false)
  }
}
</script>
